var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPersonalInformationExposure = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D5B66",
    d: "M9.777 11.504h-.482v1.208h.482c.265 0 .543-.216.543-.607 0-.39-.278-.6-.543-.6m0 0h-.482v1.208h.482c.265 0 .543-.216.543-.607 0-.39-.278-.6-.543-.6m13.97-2.14H3.865a.347.347 0 0 0-.347.346v6.256c0 .19.155.347.347.347h19.882a.347.347 0 0 0 .347-.347V9.71a.347.347 0 0 0-.347-.346M9.927 13.42h-.632v1.46h-.904v-4.086h1.537c.663 0 1.254.535 1.254 1.31 0 .83-.591 1.316-1.254 1.316m5.167 1.46H12.72v-4.086h.903v3.269h1.471zm4.033 0h-2.375v-4.086h.904v3.269h1.47zm-9.35-3.377h-.482v1.208h.482c.265 0 .543-.216.543-.607 0-.39-.278-.6-.543-.6m0 0h-.482v1.208h.482c.265 0 .543-.216.543-.607 0-.39-.278-.6-.543-.6m0 0h-.482v1.208h.482c.265 0 .543-.216.543-.607 0-.39-.278-.6-.543-.6"
  })));
};
export default SvgPersonalInformationExposure;